<template>
  <v-app dark>
    <v-navigation-drawer
      v-model="leftSideBar.drawer"
      fixed
      clipped
      app
    >
      <v-list dense>
        <template v-for="(item, i) in leftSideBar.items">
          <v-layout
            v-if="item.heading"
            :key="i"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn small flat>edit</v-btn>
            </v-flex>
          </v-layout>
          <v-divider
            v-else-if="item.divider"
            :key="i"
            dark
            class="my-3"
          ></v-divider>
          <v-list-tile
            v-else
            :key="i"
            :to="item.route"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      app
      color="deep-orange darken-2"
      fixed
      clipped-left
    >
      <v-toolbar-side-icon @click.stop="leftSideBar.drawer = !leftSideBar.drawer"/>
      <v-toolbar-title class="headline text-uppercase">
        <router-link class="toolbar-title" to="/">S-Dev</router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-content>
      <router-view/>
    </v-content>

    <v-footer
      height="auto"
      color="secondary"
    >
      <v-flex
        pa-3
        text-xs-right
        xs12
      >
        &copy;{{ year }} — <strong>S-Dev</strong>
      </v-flex>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    leftSideBar: {
      drawer: false,
      items: [
        { icon: 'fas fa-home', text: 'Accueil', route: '/' },
        { divider: true },
        { icon: 'fas fa-th', text: 'Portfolio', route: '/portfolio' },
        { divider: true },
        { icon: 'far fa-user', text: 'Qui suis-je ?', route: '/cv' },
      ],
    },
    year: (new Date()).getUTCFullYear(),
  }),
};
</script>

<style lang="stylus">
.toolbar-title
  color inherit
  text-decoration inherit
</style>
